import styled, { css } from "styled-components";

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

type AdSlotProps = { isPreview?: boolean; forcePreview: boolean };
// postcss-styled-components-disable-next-line
export const AdSlot = styled.div<AdSlotProps>`
  ${(props: AdSlotProps) =>
    (props.isPreview || props.forcePreview) && PreviewCss}
`;

const PreviewCss = css`
  background-color: rgba(0, 0, 0, 0.01);
  border: 1px dashed rgba(0, 0, 0, 0.1);
  text-align: center;
  &:after {
    content: ${(props: AdSlotProps) =>
      props.forcePreview ? '"Anzeige"' : '"Preview"'};
    color: rgba(0, 0, 0, 0.3);
  }
`;
